<div class="slide div-expand"  [ngClass]="{'print-page':print}" *ngIf="currentIndicator" >
  <header *ngIf="!print">
    <div class="row g-0">
      <div class="d-flex flex-wrap col-md-6 ">
        <b class="project-title ">
          {{currentIndicator?.project?.title}}
        </b>
        <div class="project-icons ps-3">
          <button (click)="openModal('managerProject')" class="btn btn-icon me-2" alt="Abrir Responsável" title="Abrir Responsável">
            <img  [src]="iconPersons" class="svgIcon" type="image/svg+xml">
          </button>
          <button (click)="openModal('executionProject')" class="btn btn-icon me-2" alt="Abrir Execução Orçamentária do Projeto" title="Abrir Execução Orçamentária do Projeto">
            <img [src]="iconBudget" class="svgIcon" type="image/svg+xml">
          </button>
          <a [href]="generateLinkProject(currentIndicator?.project)" class="a-icon" target="_blank" alt="Abrir projeto" title="Abrir projeto">
            <span class="icon" >open_in_new</span>
          </a>
        </div>
      </div>
      <div class="col-md-6 row g-0">
        <div class="agency-div col-lg-7 col-xl-8 col-12 pe-xl-4">
          <span>
            <b>{{currentIndicator?.agency?.str_sigla}}</b> - {{currentIndicator?.agency?.str_nome}}
          </span>
        </div>
        <div class="col-lg-5 col-xl-4 col-12 d-flex justify-content-between">
          <button (click)="openModal('achievementAndGoal')" class="btn btn-icon-2">
            <img [src]="iconLupa" class="svgIcon" type="image/svg+xml" alt="Abrir Projeção e Metas" title="Abrir Projeção e Metas">
          </button>
          <div class="timer-div">
            <span class="icon me-1">schedule</span>
            {{getCurrentTime()  | date:'HH:mm:ss':'UTC'}}
            <button class="btn btn-clock" *ngIf="!interval" (click)="startStopwatch()" title="Iniciar Timer">
              <span class="icon">play_arrow</span>
            </button>
            <button class="btn btn-clock" *ngIf="interval" (click)="stopStopwatch()" title="Pausar Timer">
              <span class="icon">pause</span>
            </button>
            <button class="btn btn-clock" (click)="resetStopwatch()" title="Reiniciar Timer">
              <span class="icon replay">replay</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <hr>
    <div class="indicator-div row g-0 mt-2">
      <div class="col-12 ps-2 col-lg-7" >
        <div class="d-flex">
          <span class="indicator-count"> Indicador {{currentIndicator?.index + 1}} de {{currentIndicator?.project?.pf_indicator.length}}</span>
          <button (click)="openModal('managerIndicator')" class="btn btn-icon">
            <img  [src]="iconPersons" class="svgIcon" type="image/svg+xml" alt="Abrir Responsável" title="Abrir Responsável">
          </button>
        </div>
       
        <h3> {{currentIndicator?.title}}</h3>
        <div class="d-flex flex-wrap mt-1">
          <div class="tag strategic mb-1"  *ngIf="currentIndicator?.level_mon_id" >Estratégico</div>
          <div class="tag irfe mb-1" *ngIf="currentIndicator?.irfe_id">IRFE</div>
        </div>
      </div>
      <div class="d-flex col-12 col-lg-5 justify-content-end" >
        <button class="btn btn-type-1"  (click)="openModal('executionIndicator')" alt="Abrir Execução Orçamentária do Indicador" title="Abrir Execução Orçamentária do Indicador">
          <img [src]="iconBudget" class="svgIcon" type="image/svg+xml">
        </button>
        <button *ngIf="statusAdm == true" class="btn btn-type-1" (click)="openModal('monitoringDemand')"  alt="Criar Demanda de Monitoramento" title="Criar Demanda de Monitoramento">
          <span class="icon" >
            folder_open
          </span>
        </button>
        <a [href]="generateLinkIndicator(currentIndicator.id,currentIndicator?.project.id)" class="btn btn-type-1" target="_blank" alt="Abrir indicador" title="Abrir indicador">
          <span class="icon" >
            open_in_new
          </span>
        </a>
        <button class="btn btn-type-1" altt="Abrir Anexos" title="Abrir Anexos" (click)="openFiles()">
          <span class="icon" >
            attach_file
          </span>
        </button>
        <button class="btn btn-type-1" (click)="showDetails = !showDetails" title="{{showDetails? 'Ocultar Detalhes': 'Ver Detalhes'}}">
          <span class="icon me-2">{{showDetails? 'visibility_off': 'visibility'}}</span>
          <span class="text-button">{{showDetails? 'Ocultar Detalhes': 'Ver Detalhes'}}</span>
        </button>

      </div>
    </div>
  </header>
  
  <table class="indicator-table">
    <thead>
      <tr>
        <th class="text-center">Medida</th>
        <th class="text-center">Polaridade</th>
        <th class="text-center">Meta Ano</th>
        <th class="text-center">Realizado</th>
        <th class="text-center">Apuração</th>
        <th class="text-center">Status</th>
        <th class="text-center">Projeção</th>
        <th class="text-center">Ponto Crítico</th>
      </tr>
    </thead>
    <tbody>
       <tr>
        <td class="text-center">{{currentIndicator?.unit_id}}
          <span class="info-text" *ngIf="currentIndicator?.accum != null&& currentIndicator?.accum_table != null">
            <br/>Acumulado
            <span class="info-text" *ngIf="currentIndicator?.accum_table">
              <br/>(visão composta)
            </span>
          </span>
          <span class="info-text" *ngIf="currentIndicator?.accum == null || currentIndicator?.accum_table == null">
            <br/>Não Acumulado
          </span>
        </td>
        <td class="text-center">
          <div class="dot dot-arrow dot-arrow-single-{{currentIndicator?.polarity? 1:3}}" title="{{polar[currentIndicator?.polarity? '1':'3']}}"></div>
        </td>
        <td class="text-center">{{(currentIndicator?.year_goal | number:'1.0-2') ?? 'NI'}}</td>
        <td class="text-center">{{(currentIndicator?.current_done | number:'1.0-2') ?? 'NI'}}</td>
          
        <td class="text-center">{{getCurrentMonth(currentIndicator)}}</td>
        <td class="text-center">
          <div class="dot dot-{{currentIndicator?.current_table_status ?? 0}}"  title="{{status[currentIndicator?.current_table_status ?? 0]}}"></div>
        </td>
        <td class="text-center">
          <div class="dot dot-arrow dot-arrow-{{currentIndicator?.pf_ind_analysis_last?.ind_analysis_stat_id ?? 0}}" 
            title="{{analysis[currentIndicator?.pf_ind_analysis_last?.ind_analysis_stat_id ?? 0]}}"></div>
        </td>
        <!--<td class="text-center">{{currentIndicator?.pf_ind_analysis_last?.ctr_dth_atu | date: 'dd/MM/YYYY H:mm:s'}}</td>-->
        <td class="text-center text-danger">{{currentIndicator?.pf_ind_critical?.length ?? 0}}</td>
      </tr>
    </tbody>
  </table>
  <hr>
  <article *ngIf="showDetails" class="details">
    <nav class="d-flex flex-wrap justify-content-between">
      <h4>{{subPages[currentSubPage]}}</h4>
      <div *ngIf="!print">
        <button class="btn-type-1 " [ngClass]="{'active':currentSubPage == 'analysis'}" (click)="currentSubPage = 'analysis'" *ngIf="currentIndicator?.pf_ind_analysis_last?.description != null || currentIndicator?.pf_ind_critical?.length > 0"> 
          <img [src]="iconAnalysis" class="svgIcon" type="image/svg+xml">
          Mostrar Análise
        </button>
        <button class="btn-type-1" [ngClass]="{'active':currentSubPage == 'previous'}" (click)="currentSubPage = 'previous'" *ngIf="currentIndicator?.pf_indicator_ref?.pf_ind_table != null"> 
          <img [src]="iconPrevious" class="svgIcon" type="image/svg+xml">
          Mostrar Exercícios Anteriores
        </button>
        <button class="btn-type-1" [ngClass]="{'active':currentSubPage == 'done'}" (click)="currentSubPage = 'done'" *ngIf="currentIndicator?.pf_ind_table != null"> 
          <img [src]="iconDoneCheck" class="svgIcon" type="image/svg+xml">
          Mostrar Realizado
        </button>
        <button class="btn-type-1" [ngClass]="{'active':currentSubPage == 'graph'}" (click)="currentSubPage = 'graph'"> 
          <img [src]="iconShowGraph" class="svgIcon" type="image/svg+xml">
          Mostrar Grafico
        </button>
      </div>
    </nav>
    <section *ngIf="currentSubPage == 'analysis' || print" class="row g-0 pe-0">
      <div class="break-word td-description" [ngClass]="{'col-md-6': !print, ' col-md-12':print}" >
        <p>
          {{currentIndicator?.pf_ind_analysis_last?.description}}
          <b>Atualização: {{currentIndicator?.pf_ind_analysis_last?.ctr_dth_atu | date: 'dd/MM/YYYY'}}</b>
        </p>
      </div>
      <div #carouselDiv class="carouselDiv" *ngIf="currentIndicator?.pf_ind_critical?.length > 0" [ngClass]="{'col-md-6': !print, ' col-md-12':print}">
        <div #carousel class="carousel" >
          <ng-container *ngFor="let critical of currentIndicator?.pf_ind_critical">
            <div class="critical-div" [style.width.px]="getCarouselWidth()">
              <div class="d-flex justify-content-between mb-2">
                <div class="d-flex">
                  <h4>Ponto crítico</h4>
                  <div class="dot dot-critical-{{getStatus(critical)}}" title="{{status[getStatus(critical)]}}" ></div>
                </div>
                <div class="d-flex" *ngIf="!print">
                  <button class="btn carousel-control prev" (click)="previous()" [disabled]="!canGoPrevious">
                    <span class="icon">arrow_back</span>
                  </button>
                  <button class="btn carousel-control next" (click)="next()" [disabled]="!canGoNext">
                    <span class="icon">arrow_forward</span>
                  </button>
                </div>
              </div>
              <div class="carousel">
                <div class="break-word td-description">
                  <p>
                    {{critical.description}}
                    <b>Atualização: {{critical?.ctr_dth_atu | date: 'dd/MM/YYYY'}}</b>
                  </p>
                  
                </div>
              </div>
              <button class="btn btn-action" *ngIf="critical?.pf_ind_action?.length > 0 && !print"  (click)="currentCritical=critical; openModal('actions')">
                <span>
                  <img [src]="iconAction" class="svgIcon" type="image/svg+xml" alt="Abrir plano de ação" title="Abrir plano de ação">
                  Mostrar plano de ação 
                </span>
              </button>
              <div  *ngIf="print">
                <div class="div-actions" *ngFor="let action of critical.pf_ind_action">
                  <h4>Plano de Ação</h4>
                  <div class="break-word td-description">
                    <p>
                      {{action.title}}
                      <b>Atualização: {{action?.ctr_dth_atu | date: 'dd/MM/YYYY'}}</b>
                    </p>
                    
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <div #carouselDiv2 *ngIf="currentIndicator?.pf_ind_critical?.length == 0"  class=""  [ngClass]="{'col-md-6': !print, ' col-md-12':print}">
        <div class="critical-div">
          <div class="d-flex justify-content-between mb-2">
            <div class="d-flex">
              <h4>Ponto crítico</h4>
            </div>
          </div>
          <div class="break-word td-description">
            <p>
              Não há ponto crítico cadastrado.
            </p>
            
          </div>
        </div>
      </div>
    </section>
    <section *ngIf="currentSubPage == 'previous' || print">
      <h4 *ngIf="print && currentIndicator?.pf_indicator_ref?.pf_ind_table != null">{{subPages['previous']}}</h4>
      <div class="system-table" *ngIf="currentIndicator?.pf_indicator_ref?.pf_ind_table as ind_table">
        <div class="system-table-conteiner">
          <table>
            <tr>
              <th class="row-header">#</th>
              <td *ngFor="let item of ind_table">
                <div >
                  {{ formatData(currentIndicator,item) }}
                </div>
              </td>
            </tr>
            <tr>
              <th class="row-header">Meta</th>
              <td *ngFor="let item of ind_table">
                <div >
                  {{ (item.goal | number:'1.0-2') ?? '' }}
                </div>
              </td>
            </tr>
            <tr>
              <th class="row-header">Realizado</th>
              <td *ngFor="let item of ind_table">
                <div>
                  {{ (item.done | number:'1.0-2') ?? '' }}
                </div>
              </td>
            </tr>
            <tr>
              <th class="row-header">Status</th>
              <td *ngFor="let item of ind_table">
                <div>
                  <div class="dot dot-{{getDot(currentIndicator,item)}}"></div>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </section>
    <section *ngIf="currentSubPage == 'done' || print">
      <h4 *ngIf="print && currentIndicator?.pf_ind_table != null">{{subPages['done']}}</h4>
      <div class="system-table" *ngIf="currentIndicator?.pf_ind_table as ind_table">
        <div class="system-table-conteiner">
          <table>
            <tr>
              <th class="row-header">#</th>
              <td *ngFor="let item of ind_table">
                <div>
                  {{ formatData(currentIndicator,item) }}
                </div>
              </td>
            </tr>
            <tr>
              <th class="row-header">Meta</th>
              <td *ngFor="let item of ind_table">
                <div >
                  {{ (item.goal | number:'1.0-2') ?? '' }}
                </div>
              </td>
            </tr>
            <tr>
              <th class="row-header">Realizado</th>
              <td *ngFor="let item of ind_table">
                <div>
                  {{ (item.done | number:'1.0-2') ?? '' }}
                </div>
              </td>
            </tr>
            <tr>
              <th class="row-header">Status</th>
              <td *ngFor="let item of ind_table">
                <div>
                  <div class="dot dot-{{getDot(currentIndicator,item)}}"></div>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </section>
    <section *ngIf="currentSubPage == 'graph' || print">
      <h4 *ngIf="print">{{subPages['graph']}}</h4>
      <div class="d-flex justify-content-center">
        <canvas baseChart id="chart-graph-{{slide}}" class="chart" [data]="currentGraph?.chartData" [options]="currentGraph?.chartOptions" 
          [type]="currentGraph?.chartType"  [height]="print? 300: ''" [width]="print? 500: ''"></canvas>
      </div>
      <div class="d-flex justify-content-center div-img" *ngIf="print" >
        <img id="img_chart-graph-{{slide}}"  [height]="print? 300: ''" [width]="print? 500: ''">
      </div>
    </section>
  </article>

</div>
<footer class="footer-page" *ngIf="!print">
  <button class="btn page-control prev" title="Indicador Anterior"  (click)="changeSlide(slide-1)" [disabled]="!(slide > 0)">
    <span class="icon">arrow_back</span>
  </button>
  <select class="form-select slide-select" [(ngModel)]="slide" (change)="changeSlide(+slide)">
    <option *ngFor="let item of listSlide" [value]="item.id">
      {{ item.label }}
    </option>
  </select>
  <button class="btn page-control next" title="Próximo Indicador" (click)="changeSlide(slide+1)" [disabled]="!(slide + 1 < indicators?.length)">
    <span class="icon">arrow_forward</span>
  </button>
</footer>

<ng-template #modal>
  <app-apresentacao-slide-modal 
    [currentIndicator]="currentIndicator" 
    [currentCritical]="currentCritical"
    [titleId]="currentModalId" 
    [filters]="filters" 
    (closeModal)="closeModal()">
  </app-apresentacao-slide-modal>
</ng-template>
<ng-template #modalFiles>
  <app-thumbnail-files-list 
    title="Anexos"
    [listFiles]="currentFiles"
    [service]="myService"
    (closeModal)="closeModal()">
  </app-thumbnail-files-list>
</ng-template>
<app-loading [loader]="isLoading"></app-loading>